import { db } from './config';
import { collection, getDocs, doc, getDoc, orderBy, query } from 'firebase/firestore';

export const getPortfolioData = async () => {
    try {
        const [bioDoc, skillsSnapshot, experiencesSnapshot, projectsSnapshot, educationSnapshot] = await Promise.all([
            getDoc(doc(db, 'bio', 'profile')),
            getDocs(query(collection(db, 'skills'), orderBy('order'))),
            getDocs(query(collection(db, 'experiences'), orderBy('order'))),
            getDocs(collection(db, 'projects')),
            getDocs(query(collection(db, 'education'), orderBy('order')))
        ]);

        return {
            bio: bioDoc.exists() ? bioDoc.data() : null,
            skills: skillsSnapshot.docs.map(doc => doc.data()),
            experiences: experiencesSnapshot.docs.map(doc => doc.data()),
            projects: projectsSnapshot.docs.map(doc => doc.data()),
            education: educationSnapshot.docs.map(doc => doc.data())
        };
    } catch (error) {
        console.error('Error fetching portfolio data:', error);
        throw error;
    }
};
